import script from "./Sentence.vue?vue&type=script&setup=true&lang=js"
export * from "./Sentence.vue?vue&type=script&setup=true&lang=js"

import "./Sentence.vue?vue&type=style&index=0&id=685a6ba1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685a6ba1"]])

export default __exports__